import axios from "axios"
// import _ from "underscore"
import qs from 'qs'
import * as util from "./util";


// axios.defaults.withCredentials = true

var instance = axios.create({
    baseURL: '/testback/',
    timeout: 5000,
    headers: { "Accept": "application/json;charset=UTF-8" },
    responseType: 'json',
    withCredentials: true, // 携带跨域cookie

    //对url参数进行二次编辑
    paramsSerializer: function(data) {
        let info = JSON.stringify(data);
        let auth = JSON.stringify(util.getauth());
        let d = {
            info: info,
            auth: auth
        }
        return qs.stringify(d);
        // return qs.stringify(params, { arrayFormat: 'brackets' })
    },

    //对post参数进行二次编辑
    transformRequest: [function(data) {
        let info = JSON.stringify(data);
        let auth = JSON.stringify(util.getauth());
        let d = {
                info: info,
                auth: auth
            }
            // console.log( qs.stringify(d));

        return qs.stringify(d);

    }],

    //对返回值进行二次编辑
    // transformResponse: [function(data) {
    //     return data;
    // }],
    //httpAgent: new http.Agent({ keepAlive: true }),
    //httpsAgent: new https.Agent({ keepAlive: true }),
});


instance.interceptors.request.use(function(config) {
    config = {
        ...config,
        _v: Date.now()
    }
    return config
}, function(error) {
    return Promise.reject(error);
})

// Add a response interceptor
instance.interceptors.response.use(function(response) {
    // if (response && response.data && response.data.success) {
    if (response.status == 200 && response.data) {
        return response.data
    }
    let error = new Error('服务器异常，请稍后再试!')
    console.log(response)
    error.code = response.status
    error.data = response.statusText
    error.requrl = response.config.url
    throw error
}, function(error) {
    let err = new Error()
        // handle timeout
    if (error.config.method == 'get' && error.message.indexOf('timeout') == 0) {
        let retry = error.config['retry'] || 1
        if (retry >= 3) {
            err.code = 400
            err.message = '网络异常，请稍后再试!'
        } else {
            // 解决base url的问题
            error.config.url = error.config.url.replace(/\/api/g, '')
            error.config['retry'] = retry + 1
            return instance.request(error.config)
        }
    } else {
        // handle other error
        err.code = 500
        err.message = '服务器异常，请稍后再试!'
        if (error && error.response) {
            if (error.response.data) {
                let data = error.response.data
                err.code = data.code || 500
                err.message = data.message || '服务器异常，请稍后再试!'
            } else if (error.response.status !== 500) {
                err.code = 400
                err.message = '网络异常，请稍后再试!'
            }
        }
    }
    return Promise.reject(err)
})


// ----  接口定义开始-----
let defines = {

    /**
     * 查找患者列表
     * @param params
     * @returns {AxiosPromise}
     */
    patient: (params) => {
        let url = "/patient/selectPatientListByAccountId"
        return instance.post(url, params)
    },


    /**
     * 修改患者信息
     * @param params
     * @returns {AxiosPromise}
     */
    updatePatient: (params) => {
        let url = "/patient/updatePatient"
        return instance.post(url, params)
    },

    /**
     * 添加患者
     * @param params
     * @returns {AxiosPromise}
     */
    addPatient: (params) => {
        let url = "/patient/addPatient"
        return instance.post(url, params)
    },


    /**
     * 视频记录列表
     * @param params
     * @returns {AxiosPromise}
     */
    RecordList: (params) => {
        let url = "/videos/videoHistory"
        return instance.post(url + params)
    },

    /**
     * 判断是否视频问诊会员
     * @param params
     * @returns {AxiosPromise}
     */
    checkUserCan: (params) => {
        let url = "/videos/checkUserCanVideo"
        return instance.post(url, params)
    },

    /**
     * 获取评价信息
     * @param params
     * @returns {AxiosPromise}
     */
    EvaluationInfo: (params) => {
        let url = "/videos/tencentEvaluationInfo"
        return instance.post(url + params)
    },

    /**
     * 获取评价标签
     * @param params
     * @returns {AxiosPromise}
     */
    Comment: (params) => {
        let url = "/comment/tag"
        return instance.post(url + params)
    },

    /**
     * 评价
     * @param params
     * @returns {AxiosPromise}
     */
    Evaluation: (params) => {
        let url = "/videoEvaluation/getEvaluation"
        return instance.post(url + params)
    },
    // 获取资讯文章内容
    getContent: (params) => {
        let url = "/dissertation/getDissertationById"
        return instance.post(url, params)
    },
    //获取评论和回复
    getData: (params) => {
        let url = "/dissertation/getCommentAndReply"
        return instance.post(url, params)
    },
    //发送回复
    postHf: (params) => {
        let url = "/dissertation/addReply"
        return instance.post(url, params)
    },
    //发送评论
    postPl: (params) => {
        let url = "/dissertation/addComment"
        return instance.post(url, params)
    },
    //健康等tab资讯
    getListData: (params) => {
        let url = "/dissertation/getDissertation"
        return instance.post(url, params)
    },
    //优惠券
    postCoupon: (params) => {
        let url = "/coupon/getCollectByCustomerId"
        return instance.post(url, params)
    },
    //附近医院列表
    postClinicList: (params) => {
        let url = "/clinic/list"
        return instance.post(url, params)
    },
    //附近医院列表
    postClinicListDetail: (params) => {
        let url = "/clinic/detail"
        return instance.post(url, params)
    },
    //顶部图片swiper
    postClinicListImage: (params) => {
        let url = "/pic/img"
        return instance.post(url, params)
    },
    //获取服务nav
    postClinicListNav: (params) => {
        let url = "/common/getMenuListOfClinicForClient"
        return instance.post(url, params)
    },
    //热门服务
    postClinicListService: (params) => {
        let url = "/prd/getTreatCardList"
        return instance.post(url, params)
    },
    // 首页热门服务
    clinicListService: (params) => {
        let url = "/prd/getProductInfo"
        return instance.post(url, params)
    },
    //特色科室
    postClinicListKeshi: (params) => {
        let url = "/prdClinicDept/getSpecialDeptByClinic"
        return instance.post(url, params)
    },
    //医生列表 li
    postDoctorList: (params) => {
        return instance.post('/doctor/doctorList.json', params)
    },
    // 医生详情页的医生的基本信息 li
    postDoctorDetail: (params) => {
        return instance.post('/doctor/doctorDetail.json', params)
    },
    // 医生详情页的擅长、简介 li
    getDoctorIntroduce: (params) => {
        return instance.get('/doctor/doctorIntroduce', { params: params })
    },
    // 医生详情页的医生功能的接口 li
    postDoctorsServices: (params) => {
        return instance.post('/doctor/getDoctorsServices', params)
    },
    // 医生详情页的评价的接口 li
    postDoctorAssess: (params) => {
        return instance.post('/doctor/doctorAssess.json', params)
    },
    // 得到省级数据
    postProvinceData: (params) => {
        return instance.post('/publicarea/getAreaByLevel1', params)
    },
    // 得到与省级相应的市级数据
    postCityData: (params) => {
        return instance.post('/publicarea/getAreaByLevel2', params)
    },
    // 得到热闹城市数据
    postHodCityData: (params) => {
        return instance.post('/publicarea/all', params)
    },
    // 得到区的列表
    postAreaData: (params) => {
        return instance.post('/publicarea/getAreaByParent', params)
    },
    // 得到主要科室数据
    postDept: (params) => {
        return instance.post('/dept/all', params)
    },
    // 得到子级科室数据
    postDeptSub: (params) => {
        return instance.post('/dept/deptByParentid', params)
    },
    //电话咨询请求接口
    phoneConsole: (params) => {
        return instance.post('cliPhoneCall/getPhoneCallStatus', params)
    },
    //分享接口
    shareContent: (params) => {
        return instance.get('/pro/getQrcodeInfo', { params: params })
    },
    //HPV商品详情
    hpvInfo: (params) => {
        return instance.post('/homecare/detail', params)
    },
    //HPV根据患者账号，获取患者信息
    hpvManInfo: (params) => {
        return instance.post('/patient/selectPatientListByAccountId', params)
    },
    //HPV根据患者信息创建订单
    hpvCreateOrder: (params) => {
        return instance.post('/homecare/addServiceOrder', params)
    },
    // 得到护士服务列表数据
    serveList: (params) => {
        return instance.post('/homecareType/getHomecareListByProducttypeNew', params)
    },
    // 得到服务详情页面的数据
    serveDatail: (params) => {
        return instance.post('/homecare/detail', params)
    },
    // 预约服务拿bookid，orderid
    servePay: (params) => {
        return instance.post('/homecare/addServiceOrder', params)
    },
    // 套餐购买
    setmeal: (params) => {
        return instance.post('/prd/generaterCardOrder', params)
    },
    //app首页 健康管理 基因检测 vip数据
    serveOtherList: (params) => {
        return instance.post('/label/getListInfoForLableV1', params)
    },
    //订单详情
    orderDetail: (params) => {
        return instance.post('/payservice/intoOrderDetail', params)
    },
    //获取订单优惠券
    couponList(params) {
        return instance.post('/coupon/getAvailableCouponInfo', params)
    },
    //查询订单状态 
    checkStatus(params) {
        return instance.post('/order/detail', params)
    },
    //h5支付
    pay(params) {
        return instance.post('/payservice/payfortran', params)
    },
    //hh
    // paya(params){
    //     return instance.post('//wxtest.oasisapp.cn/wechat/v2/wechat/oauth2', params) 
    // },
    paya: (params) => { //上传图片  base64
        return axios({
            // baseURL: util.isOnline() ? '//gw.oasisapp.cn' : '//gwtest.oasisapp.cn',
            // timeout: 30000,
            method: 'get',
            // headers: {
            //     "Accept": "application/json;charset=UTF-8",
            //     "Auth": JSON.stringify(util.getAuth())
            // },
            // responseType: 'json',
            withCredentials: true,
            url: "//wxtest.oasisapp.cn/wechat/v2/wechat/oauth2",
            data: params
        })
    },
    // 附加事项接口
    conditionList: (params) => {
        return instance.post('/bookedService/toConfirmServiceOrder', params)
    },
    //患者列表接口
    patientList: (params) => {
        return instance.post('/patient/selectPatientListByAccountId', params)
    },
    // 预约服务下订单
    payServeOrder: (params) => {
        return instance.post('/bookedService/doAddBookedV1', params)
    },
    //设置默认患者接口
    setDefaultPatient: (params) => {
        return instance.post('/patient/setDefaultPatient', params)
    },
    //删除(逻辑删除)患者接口
    deletePatient: (params) => {
        return instance.post('/patient/updateDelStatus', params)
    },
    //新增患者接口
    createPatient: (params) => {
        return instance.post('/patient/addPatient', params)
    },
    //修改用户患者信息接口
    updatePatient: (params) => {
        return instance.post('/patient/updatePatient', params)
    },
    //获取搜索模糊匹配数据
    searchDatas: (params) => {
        return instance.get('/publicarea/baidu-address' + params)
    },
    cancleOrder: (params) => {
        return instance.post('/bookedService/doCustomerCancelBooked', params)
    },
    //获取用户信息
    userInfo: (params) => {
        return instance.post('/user/userInfo', params)
    },
    //获取分享地址
    shareUrl: (params) => {
        return instance.get('/pro/getUrl' + params)
    },
    // 添加评论
    addComment: (params) => {
        return instance.post('/comment/add', params)
    },
    //首页球球数据
    headersBall: (params) => {
        return instance.post('/common/getMenuListForClient', params)
    },
    changeCode: (params) => {
        return instance.post('/bookedService/motifyOrderid', params)
    },
    // 端午活动页推荐列表
    dragGoodsList: (params) => {
        return instance.post('/phyGoods/temporaryGoodsList', params)
    },
    //查询名医风采
    getDoctorList: (params) => {
        return instance.post('/doctor/topDoctors', params)
    },
    //查询所有服务接口
    searchService: (params) => {
        return instance.post('/homecareType/getHomecareListByType', params)
    },
    //查询电话咨询护士列表
    searchNurse: (params) => {
        return instance.post('/nurse/getTelphoneServiceListOfNurse', params)
    },
    //查询电话咨询医生列表
    searchDoctor: (params) => {
        return instance.post('/doctor/getTelphoneServiceListOfDoctor', params)
    },
    //查询护士详情
    nurseDetail: (params) => {
        return instance.post('/nurse/nurseMainInfo', params)
    },
    //护士简介
    nurseIntroduce: (params) => {
        return instance.get('/nurse/nurseIntroduce', { params: params })
    },
    //查询护士服务
    nursesServices: (params) => {
        return instance.post('/nurse/getNursesServices', params)
    },
}

let apis = {}
Object.keys(defines).forEach((name) => {
    apis[name] = function(params) {
        var req = defines[name](params)
        return req;
    };
});
export default apis


// WEBPACK FOOTER //
// ./src/lib/api.oasis.js